import React, { useState, useCallback, memo } from 'react';
import connect from 'Shared/connect';
import Icon from 'Shared/Icon';
import * as styles from './base.scss';
import { translate } from 'Shared/translate';
import classnames from 'classnames';
import AddToListDialog from './AddToListDialog';
export function isInList(listThatActuallyIsObject) {
    return listThatActuallyIsObject && Object.keys(listThatActuallyIsObject).length > 0;
}
const AddRemoveList = memo((props) => {
    const [isAddToListOpen, setAddToListOpen] = useState(false);
    const handleOpenAddToList = useCallback(() => setAddToListOpen(true), []);
    const handleCloseAddToList = useCallback(() => setAddToListOpen(false), []);
    const properties = {
        favorites: {
            isDisabled: props.disableFavoriteList || !!props.product.isCustom || props.product.isUtf,
            text: translate('/Product/Favorite'),
            uiTestClass: 'ui-test-add-remove-favorites',
            isActive: isInList(props.product.favoritesList),
            iconName: 'heart-outline',
            lists: props.product.favoritesList,
        },
        pantries: {
            isDisabled: props.disablePantry || props.product.isUtf,
            text: translate('/Product/Pantry'),
            uiTestClass: 'ui-test-add-remove-pantries',
            isActive: isInList(props.product.pantriesList),
            iconName: 'list-bulleted',
            lists: props.product.pantriesList,
        },
    };
    const currentProperties = properties[props.type];
    return currentProperties.isDisabled ? null : (React.createElement("div", { className: styles.listAdd, title: currentProperties.text },
        React.createElement("div", { className: classnames(props.className, styles.small, currentProperties.uiTestClass), "data-code": props.code, onClick: handleOpenAddToList },
            React.createElement("div", { className: classnames(styles.circle, {
                    [styles.activeIcon]: currentProperties.isActive,
                    [props.className]: currentProperties.isActive,
                }) },
                React.createElement(Icon, { appearance: "sans", name: currentProperties.iconName }))),
        React.createElement(AddToListDialog, { isOpen: isAddToListOpen, close: handleCloseAddToList, code: props.code, type: props.type, listsContainingProduct: currentProperties.lists })));
});
export default connect((state) => ({
    disablePantry: state.appShellData.disablePantry,
    disableFavoriteList: state.appShellData.disableFavoriteList,
}))(AddRemoveList);
